__turbopack_context__.v({
  "benefitsContainer": "benefits-module-scss-module__RGLP7a__benefitsContainer",
  "benefitsDescription": "benefits-module-scss-module__RGLP7a__benefitsDescription",
  "benefitsTitle": "benefits-module-scss-module__RGLP7a__benefitsTitle",
  "benefitsWrp": "benefits-module-scss-module__RGLP7a__benefitsWrp",
});
